<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div class="default-padding">
  <div class="label-container">
    <h4 id="header-text">{{ headerText }}</h4>
  </div>
  <div class="options-container">
    <mat-selection-list [multiple]="isMultiSelect" [(ngModel)]="selectedOptions">
      <mat-list-option *ngFor="let element of customDataDisplay"
                       [value]="element.data"
                       matTooltip="{{element.displayValue}}"
                       matTooltipPosition="before">
        {{element.displayValue}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="button-container default-padding">
  <button mat-flat-button id="select-all-button" class="action-button default-margin"
          (click)="onSelectAll()">
    Select All
  </button>

  <button mat-stroked-button id="cancel-button" class="action-button default-margin"
          (click)="onCancel()">
    Cancel
  </button>

  <button mat-raised-button color="primary" id="confirm-button" class="action-button default-margin"
          (click)="onConfirm()"
          [disabled]="!selectedOptions || selectedOptions.length === 0">
    Confirm
  </button>
</div>
